module.exports = __webpack_public_path__ + "static/media/018-pharmacy.a4a55649.svg";